const YOUTUBE_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
const VIMEO_RE = /(?:vimeo\.com\/)([0-9]+)/;

export function getEmbedUrl(url: string): string | null {
  const yt = url.match(YOUTUBE_RE);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}`;

  const vi = url.match(VIMEO_RE);
  if (vi) return `https://player.vimeo.com/video/${vi[1]}?dnt=1`;

  return null;
}
